import type { ChartData } from '../types'

const getStepFromData = (values: number[]) => {
  const maxAbs = Math.max(...values.map((v) => Math.abs(v)))
  const magnitude = 10 ** Math.floor(Math.log10(maxAbs))

  return magnitude
}

const roundDownToAutoStep = (value: number, values: number[]) => {
  const step = getStepFromData(values)

  return Math.floor(value / step) * step
}

export const getMinValue = (data: ChartData[]) => {
  if (!data || data.length === 0) {
    return 0
  }

  const allValues: number[] = []
  for (const series of data) {
    for (const point of series.data) {
      allValues.push(point.value)
    }
  }

  if (allValues.length === 0) {
    return 0
  }

  let minValue = 0
  for (const value of allValues) {
    if (value < minValue) {
      minValue = value
    }
  }

  return roundDownToAutoStep(minValue, allValues)
}
